'use client';

import { useMemo } from 'react';
import useGlobalConfig from '@homeflow/v4-lib/hooks/use-global-config';
import { SearchForm } from '@homeflow/v4-lib/state';
import { OPEN_HOUSE_TAGS } from '../../../search-form-settings';

export function useOpenHouseTagData(
  extraSettings?: SearchForm['extraSettings']
): { tag: string; label: string }[] {
  const globalExtraSettings = useGlobalConfig()?.searchForm?.extraSettings;
  const settings = extraSettings ?? globalExtraSettings;

  return useMemo(
    () =>
      OPEN_HOUSE_TAGS.map(({ tag, key }) => ({
        tag,
        label: settings?.[key] ?? '',
      })).filter(({ label }) => !!label),
    [settings]
  );
}

export default function OpenHouseDate({ tags }: { tags: string[] }) {
  const tagData = useOpenHouseTagData();
  const foundTag = tagData.find(({ tag }) => tags.includes(tag));
  return foundTag ? <>{foundTag.label}</> : null;
}
